import { render, staticRenderFns } from "./TrustCenter.vue?vue&type=template&id=3ffcface&scoped=true"
import script from "./TrustCenter.vue?vue&type=script&lang=js"
export * from "./TrustCenter.vue?vue&type=script&lang=js"
import style0 from "./TrustCenter.vue?vue&type=style&index=0&id=3ffcface&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffcface",
  null
  
)

export default component.exports